import { RadioGroup } from '@headlessui/react';
import { useField } from 'formik';

export default function RadioBigGroup({ name, label, options }) {
  const [field, meta, helpers] = useField(name);

  const { setValue } = helpers;

  return (
    <div className="mt-6 sm:mt-5 space-y-6 sm:space-y-5">
      <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-primary-200 sm:pt-5">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label className="block text-base font-medium text-primary-700 sm:mt-px sm:pt-2">
          {label}
        </label>
        <RadioGroup
          value={field.value}
          onChange={setValue}
          className="col-span-2"
        >
          <RadioGroup.Label className="sr-only">{label}</RadioGroup.Label>
          <div className="flex flex-col">
            {options.map((option) => (
              <RadioGroup.Option
                key={option.value}
                value={option.value}
                className={({ active, checked }) => `${
                  active
                    ? 'ring-2 ring-offset-2 ring-offset-neutral-500 ring-white ring-opacity-60'
                    : ''
                }
                  ${
                    checked
                      ? 'bg-neutral-500 bg-opacity-75 border-transparent'
                      : 'bg-white'
                  }
                    relative rounded px-5 py-4 mb-4 mx-2 cursor-pointer flex focus:outline-none border border-primary-300`}
              >
                {({ checked }) => (
                  <div className="flex items-center justify-between w-full">
                    <div className="flex items-center">
                      <div className="text-base">
                        <RadioGroup.Label
                          as="p"
                          className={`font-normal  ${
                            checked ? 'text-white' : 'text-primary-800'
                          }`}
                        >
                          {option.label}
                        </RadioGroup.Label>
                      </div>
                    </div>
                  </div>
                )}
              </RadioGroup.Option>
            ))}
          </div>
        </RadioGroup>

        {meta.touched && meta.error ? (
          <div className="error text-base font-small text-warning ">
            {meta.error}
          </div>
        ) : null}
      </div>
    </div>
  );
}
